export default "__VITE_ASSET__D$X3Jgbb__"